import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  // null = checking, false = unauthenticated, object = authenticated user
  const [adminUser, setAdminUser] = useState(null);

  const verify = useCallback(async () => {
    const token = localStorage.getItem('mb-admin-token');
    if (!token) {
      setAdminUser(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAdminUser(data);
    } catch {
      localStorage.removeItem('mb-admin-token');
      setAdminUser(false);
    }
  }, []);

  useEffect(() => { verify(); }, [verify]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem('mb-admin-token', data.access_token);
    setAdminUser({ email: data.email, role: 'admin' });
    return data;
  };

  const logout = () => {
    localStorage.removeItem('mb-admin-token');
    setAdminUser(false);
  };

  return (
    <AdminAuthContext.Provider value={{ adminUser, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
